import type { ElementType, ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function Container({
  as: Comp = 'div',
  className,
  children,
}: {
  as?: ElementType
  className?: string
  children: ReactNode
}) {
  return <Comp className={cn('mx-auto w-full max-w-site px-8', className)}>{children}</Comp>
}
